import { render, staticRenderFns } from "./uploader-iframe.vue?vue&type=template&id=19b88b16"
import script from "./uploader-iframe.vue?vue&type=script&lang=js"
export * from "./uploader-iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports